/** @file Whether a label anchor lies in the view (edges included): the test placement starts with. */

/** True when (x, y) is inside [0, width] x [0, height]; NaN anywhere is outside. */
export function anchorInView(x: number, y: number, width: number, height: number): boolean {
  return x >= 0 && y >= 0 && x <= width && y <= height;
}
